import document from 'global/document';

export const fireElementCustomEvent = (element, eventName, data = null) => {
  let event = null;

  if (data) {
    event = new CustomEvent(eventName, {
      detail: data,
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, false);
  }

  try {
    element.dispatchEvent(event);
  } catch (err) {
    console.error(`Error dispatching custom event "${eventName}":`, err);
  }
};

export const fireCustomEvent = (eventName, data = null) => {
  fireElementCustomEvent(document, eventName, data);
};
